import axios from "axios";

// Unwrap ResponseEnvelopeMiddleware: {success, data, timestamp} → data
function _unwrapEnvelope(res) {
  if (res.data && typeof res.data === "object" && "success" in res.data && "data" in res.data) {
    res.data = res.data.data;
  }
  return res;
}

export function estafetaAxios(token) {
  const instance = axios.create({
    headers: { Authorization: `Bearer ${token}` },
  });
  instance.interceptors.response.use(_unwrapEnvelope);
  return instance;
}
